// Ajitesh : 16/02/2024: BT-109380 Contact Us - Start
import { memo, useEffect, useState } from "react";
import { BzButton, BzDotsLoader, BzInputText, BzModal, BzModalBody, BzModalHeader } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../redux/actions/modals";
import { Col, Container, Row } from "react-bootstrap";
import { getBranchDetails } from "../../redux/actions/help";
import { useDebounce } from "../../hooks";
import ZeroStates from "../ZeroStates";

const ViewBranches = () => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const branchesList = useSelector(state => state?.help?.branchDetails);
    const isBranchesListLoading = useSelector(state => state?.help?.isLoadingBranchesInfo);
    const [branches, setBranches] = useState([]);

    // Vinit R - 02-05-2024 BT-109380 Contact Us -- Start
    useEffect(() => {
        if (modals["VIEW_BRANCHES_MODAL"]) {
            dispatch(getBranchDetails());
        }
    }, [modals, dispatch]);

    useEffect(() => {
        setBranches(branchesList);
    }, [branchesList]);
    // Vinit R - 02-05-2024 BT-109380 Contact Us -- End

    const handleClose = () => {
        dispatch(handleModal([{ "VIEW_BRANCHES_MODAL": false }]));
    };

    const onBranchSearchChange = (branchCity) => {
        useDebounce(() => {
            if (branchCity === "") {
                setBranches(branchesList);
            }
            else {
                const filteredBranches = branches.filter((branch) => branch.sCity.toLowerCase().includes(branchCity.toLowerCase()));
                setBranches(filteredBranches);
            }
        });
    };

    const handleLocateBranch = (lat, long) => {
        window.open(`https://maps.google.com/?q=${lat},${long}`);
    };

    return (
        <BzModal show={modals["VIEW_BRANCHES_MODAL"]} onHide={handleClose} className='modal-viewbranches'>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>View Branches</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='viewbranches-modal-body'>
                <Container fluid className='p-0'>
                    <Row className='g-0 mb-2'>
                        <Col>
                            <div className='position-relative'>
                                <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                <BzInputText onChange={(e) => onBranchSearchChange(e.target.value)} disabled={branchesList.length === 0} size='sm' type='search' placeholder='Search by city' className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                            </div>
                        </Col>
                    </Row>
                    <div className='mb-3 viewbranches-scroll'>
                        {
                            isBranchesListLoading ? <BzDotsLoader /> : branches.length > 0 ?
                                branches.map((branch) => (
                                    <Container fluid className='p-0 bdr-btm'>
                                        <div className='p-2'>
                                            <Row className='g-0 mb-1'>
                                                <Col className='d-flex justify-content-start align-items-start'>
                                                    <div className='font-medium font-size3 color-text'>{branch.sBranchName}</div>
                                                </Col>
                                                <Col className='d-flex justify-content-end align-items-start'>
                                                    <div className='font-medium font-size1 color-text'>{branch.sCity}</div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-1'>
                                                <Col className='d-flex justify-content-start align-items-start'>
                                                    <div className='font-medium font-size3 color-text'>Address: <span className='font-regular'>{branch.sBranchAddress}</span></div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-1'>
                                                <Col className='d-flex justify-content-start align-items-start'>
                                                    <div className='font-regular font-size3 color-text'>Pincode: <span className='font-medium'>{branch.sPincode}</span></div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 mb-2'>
                                                <Col className='d-flex justify-content-start align-items-start'>
                                                    <div className='font-regular font-size3 color-text'>Contact Person: <span className='font-medium'>{branch.sContactPerson}</span></div>
                                                </Col>
                                            </Row>
                                            <Row className='g-0 pt-2'>
                                                <Col className='d-flex'>
                                                    <a href={`tel:${branch.sContactNumber}`} className='btn btn-sm btn-block btn-primary me-2'>Call Us</a>
                                                    <BzButton className='btn btn-sm btn-block btn-primary ms-2' onClick={() => handleLocateBranch(branch.sLatitude, branch.sLongitude)}>Locate Us</BzButton>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Container>
                                ))
                                : (
                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                        <ZeroStates subText="No branches found" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                    </div>
                                )
                        }
                    </div>
                </Container>
            </BzModalBody>
        </BzModal>
    );
};

export default memo(ViewBranches);
// Ajitesh : 16/02/2024: BT-109380 Contact Us - End